// eslint-disable-next-line no-shadow
enum StatusType {
  ACTIVE,
  INACTIVE,
  EXCLUDED,
}
export default StatusType;
